import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../../constants/typography';

export const useStyles = makeStyles()(
  (theme, { multipleMode, isKiteUser } = {}) => ({
    trackButton: { paddingLeft: 0 },
    fullWidth: { width: '100%' },
    root: {
      alignItems: 'baseline',
      borderRadius: 20,
      boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: multipleMode ? 'initial' : 'space-between',
      height: 190,
      padding: theme.spacing(2),
      width: 267,
      [theme.breakpoints.down('lg')]: {
        borderRadius: 10,
        height: 202,
        padding: theme.spacing(1.5),
        width: 224,
      },
      [theme.breakpoints.down('md')]: {
        height: 200,
        marginRight: theme.spacing(2),
        width: 140,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          borderRadius: 10,
          height: 202,
          padding: theme.spacing(1.5),
          width: 224,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          height: 200,
          marginRight: theme.spacing(2),
          width: 140,
        }),
      },
    },
    title: {
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 16,
      fontWeight: isKiteUser ? FONT_WEIGHT_BOLD : FONT_WEIGHT_SEMIBOLD,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        lineHeight: '16px',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 12,
          lineHeight: '16px',
        }),
      },
    },
    button: {
      fontSize: '14px',
      padding: 3,
    },
    deleteButton: {
      backgroundColor: theme.palette.lightGrey,
      borderRadius: 4,
      marginBottom: theme.spacing(2),
      maxHeight: 24,
      minWidth: 24,
      padding: 4,
      '&:hover': {
        backgroundColor: `${theme.palette.lightGrey} !important`,
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(2.5),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          marginBottom: theme.spacing(2.5),
        }),
      },
    },
    container: {
      width: 267,
      [theme.breakpoints.down('lg')]: {
        width: 224,
      },
      [theme.breakpoints.down('md')]: {
        width: 135,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          width: 224,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          width: 135,
        }),
      },
    },
  }),
);
